import { SalesContractCalendar } from "@/components/sales-contracts/sales-contract-calendar";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/sales-calendar")({
	component: SalesCalendarPage,
});

function SalesCalendarPage() {
	return (
		<div className="container mx-auto px-4 py-6">
			<div className="mb-6">
				<h1 className="text-3xl font-bold text-gray-900">Sales Calendar</h1>
				<p className="text-gray-600 mt-2">View contract start and end dates in calendar format</p>
			</div>
			<SalesContractCalendar />
		</div>
	);
}
